import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'
import type { Link } from '@/types'

type Args = {
  slug: string
  destinations: string[]
  type: 'organization' | 'team' | 'personal' | 'family'
  organizationId?: string
  teamIds?: string
  shareWith?: string
}

export const useCreateLink = () => {
  const queryClient = useQueryClient()

  return useMutation<Link, Error, Args>({
    mutationFn: async (payload) => {
      const { data } = await api.post('/links', payload)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['all-links'] })
    },
  })
}
